import pokeball from "../../assets/pokebola.png";
import AppImage from "../AppImage/AppImage";
import CardContainer from "../Card/CardContainer";
import LoadingSpinner from "../Loading/LoadingSpinner";
import Modal from "../Modal/Modal";
import PokemonCard from "../PokemonCard/PokemonCard";
import "./index.css";

function Search({
  handleOnChangeSearch,
  pokemon,
  showModal,
  handleShowModal,
  searching,
  searchValue,
  searchPokemon,
  setShowModal,
  loading,
}) {
  return (
    <>
      <p className="input-title">Qual Pokémon você quer explorar?</p>
      <p className="input-subtitle">
        Digite o nome ou número da Pokédex para abrir detalhes rapidamente.
      </p>
      <form
        className="search"
        onSubmit={(event) => {
          event.preventDefault();
          searchPokemon();
        }}
      >
        <input
          placeholder="Ex: pikachu ou 25"
          type="text"
          onChange={handleOnChangeSearch}
          value={searchValue}
        />
        <button className="pokeball" type="submit">
          <AppImage className="pokeball-img" alt="pokeball" src={pokeball} />
          <span>Buscar</span>
        </button>
      </form>

      {!searching ? <CardContainer /> : null}

      {searching && loading ? <LoadingSpinner ariaLabel="pokemon-search-loading" /> : null}

      {searching && !loading && pokemon ? (
        <div className="card-area">
          <PokemonCard key={pokemon.name} pokemon={pokemon} onClick={handleShowModal} />
        </div>
      ) : null}

      {showModal && pokemon ? (
        <Modal pokemonName={pokemon.name} setShowModal={setShowModal} />
      ) : null}
    </>
  );
}

export default Search;
